export const sleep = async (ms: number) =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export const asyncInterval = async (
  callback: (...ars: any) => boolean | undefined,
  ms = 100,
  triesLeft = 50,
): Promise<void> =>
  new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      const result = callback();
      if (result === true) {
        resolve();
        clearInterval(interval);
      } else if (result === false) {
        reject();
        clearInterval(interval);
      } else if (triesLeft <= 1) {
        reject();
        clearInterval(interval);
      }
      triesLeft--;
    }, ms);
  });
